import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pagination"
export default class extends Controller {
  static targets = ["limitSelect"]

  changeLimit(event) {
    const limit = event.target.value
    const url = new URL(window.location.href)
    
    // Update the limit parameter
    url.searchParams.set('limit', limit)
    
    // Reset to page 1 when changing limit
    url.searchParams.delete('page')
    
    // Navigate to the new URL
    window.location.href = url.toString()
  }
}
